// extracted by css-extract-rspack-plugin
export default {"arrow":"TK8YoG"};